/**
 * Validate if a phone number is valid.
 *
 * @param {string} phone
 *
 * @returns {boolean}
 */
const isPhoneValid = (phone) => {
    const regex = /^[0-9]{8,10}$/;
    return regex.test(phone);
};
export default isPhoneValid;
